import { useTranslation } from "react-i18next"
import styles from "./HomePage.module.css"
export function HomePage() {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <h1>{t("home.pageTitle")}</h1>
    </div>
  )
}
